
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import React, { Dispatch, SetStateAction } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'src/lib'
import { InstrumentoPutFields } from '../api/instrumento-fields'
import { zodResolver } from '@hookform/resolvers/zod'
import { HttpWRM } from '../api'
import toast from 'react-hot-toast'
import { AsyncSelect, ControlledTextField } from 'src/components/forms'
import { HttpCacheOperacion } from 'src/pages/sistema/api/httpCacheOperacion'

const schemaNuevoInstrumento = z.object({
    [InstrumentoPutFields.CodOperacionLimiteTipo]: z.number(),
    [InstrumentoPutFields.Excepcion]: z.string(),
    [InstrumentoPutFields.ValorNominal]: z.coerce.number(),
    [InstrumentoPutFields.CashValueUSD]: z.coerce.number(),
    [InstrumentoPutFields.Instrumento]: z.string()
})

type SchemaNuevoInstrumento = z.infer<typeof schemaNuevoInstrumento>

type DialogNuevoInstrumentoProps = {
    open: boolean
    setOpen: Dispatch<SetStateAction<boolean>>
    idOperacion: number
}

export const DialogNuevoInstrumento = ({ open, setOpen, idOperacion }: DialogNuevoInstrumentoProps) => {

    const { control, handleSubmit } = useForm<SchemaNuevoInstrumento>({
        resolver: zodResolver(schemaNuevoInstrumento),
        defaultValues: {
            [InstrumentoPutFields.Excepcion]: "Minuta"
        }
    })

    const alGuardarInstrumento = (data: SchemaNuevoInstrumento) => {
        const promise = HttpWRM.postInstrumento(idOperacion, data)

        toast.promise(promise, {
            loading: 'Guardando',
            success: 'Guardado correctamente',
            error: 'Error al guardar'
        }).then(() => setOpen(false))
    }

    // TODO: mask para decimales en vez de type='number'

    return (
        <Dialog
            open={open}
            maxWidth='sm'
            fullWidth
        >
            <DialogTitle>Nuevo instrumento</DialogTitle>
            <DialogContent>
                <Grid container spacing={4} pt={2}>
                    <Grid item xs={12} md={6}>
                        <ControlledTextField
                            control={control}
                            name={InstrumentoPutFields.ValorNominal}
                            label='Valor nominal'
                            numeric
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ControlledTextField
                            control={control}
                            name={InstrumentoPutFields.CashValueUSD}
                            label='Cash value USD'
                            numeric
                            currency
                            prefix={'USD'}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <AsyncSelect
                            control={control}
                            name={InstrumentoPutFields.CodOperacionLimiteTipo}
                            label='Límite'
                            fullWidth
                            loadOptions={() => HttpCacheOperacion.getLimiteTipos()}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ControlledTextField
                            control={control}
                            name={InstrumentoPutFields.Instrumento}
                            label='Instrumento'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ControlledTextField
                            control={control}
                            name={InstrumentoPutFields.Excepcion}
                            label='Excepción'
                            multiline
                            rows={2}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='text' color='primary' onClick={() => setOpen(false)}>
                    Cancelar
                </Button>
                <Button variant='contained' color='primary' onClick={handleSubmit(alGuardarInstrumento)}>
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
